import { Component } from '@angular/core';

@Component({
  selector: 'app-sales',
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class SalesComponent {

}
